export const url =
  'https://t6uyyfsdg7.execute-api.eu-central-1.amazonaws.com/dev/get-url?url=https://medium.com/eli5/a-modern-setup-for-digital-products-627e8c25efca%60&url=';

  export const xApiKey = 'Vmlg5egOs04xE0KeiecGa2dKpEZek4KZ1kHpm0pm'